import { eventHasRun } from '../../utils/eventTracker';
import findWidgetName from '../../utils/findWidgetName';
import findVehicleByProperty from '../../utils/findVehicleByProperty';

export const DDC_LINK_HPRODUCTCLICK = 'ddc.link.hproductClick';

function hproduct(
	{
		DDC: {
			dataLayer: { vehicles }
		}
	},
	doc,
	{ currentTarget: element, timeStamp },
	originalEvent
) {
	let eventObject;
	if (
		!eventHasRun(DDC_LINK_HPRODUCTCLICK, {
			timeStamp
		})
	) {
		let $element;
		const eventData = {};

		// if element is document then click originates from a $document.trigger('hproductClick')
		if (element === doc) {
			$element = $(originalEvent.target);
		} else {
			// element is DOM object of the clicked element
			$element = $(element);
		}

		eventData.text = $element.text().trim();
		eventData.element = $element.get(0);

		const isSRP = findWidgetName($element[0]) === 'ws-inv-listing';

		if (isSRP) {
			const vehicle = findVehicleByProperty(
				'uuid',
				$element.parents('.vehicle-card-detailed').data('uuid'),
				vehicles
			);

			eventData.vin = vehicle.vin;
			eventData.stockNumber = vehicle.stockNumber;
			eventData.make = vehicle.make;
			eventData.model = vehicle.model;
			eventData.year = vehicle.modelYear;
			eventData.bodyStyle = vehicle.bodyStyle;
			eventData.trim = vehicle.trim;
			eventData.exteriorColor = vehicle.exteriorColor;
			eventData.position = vehicle.indexPosition;
			eventData.type = vehicle.inventoryType;
			eventData.internetPrice = vehicle.internetPrice;
			eventData.msrp = vehicle.msrp;
			eventData.url = vehicle.link;
		} else {
			let hproductInternetPrice;
			let hproductMsrpValue;

			if (!$element.hasClass('hproduct')) {
				const $parents = $element.parents('.hproduct');

				if ($parents.length > 0) {
					$element = $parents;
				}
			}

			try {
				hproductInternetPrice = atob($element.data('internetprice'));
				hproductMsrpValue = atob($element.data('msrp'));
			} catch (error) {
				hproductInternetPrice = $element.data('internetprice');
				hproductMsrpValue = $element.data('msrp');
			}

			eventData.vin = $element.data('vin');
			eventData.stockNumber = $element.data('stockNumber');
			eventData.make = $element.data('make');
			eventData.model = $element.data('model');
			eventData.year = $element.data('year');
			eventData.bodyStyle = $element.data('bodystyle');
			eventData.trim = $element.data('trim');
			eventData.exteriorColor = $element.data('exteriorcolor');
			eventData.position = $element.data('index-position');
			eventData.type = $element.data('type');
			eventData.internetPrice = hproductInternetPrice;
			eventData.msrp = hproductMsrpValue;
			eventData.url = $element.find('.media a').attr('href');
		}

		eventObject = {
			eventType: DDC_LINK_HPRODUCTCLICK,
			eventData
		};
	}

	return eventObject;
}

export default hproduct;
